import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { POPULAR, RELEVANCE } from './constants';

const DEFAULT_SEARCH = '';
const DEFAULT_FILTERS = [];
const DEFAULT_SORTBY = POPULAR.value;
const DEFAULT_PAGENUM = 0;

const SearchContext = React.createContext({
  search: DEFAULT_SEARCH,
  filters: DEFAULT_FILTERS,
  sortBy: DEFAULT_SORTBY,
  pageNum: DEFAULT_PAGENUM,
});

const SearchProvider = ({ children }) => {
  const [search, setSearch] = useState(DEFAULT_SEARCH);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [sortBy, setSortBy] = useState(DEFAULT_SORTBY);
  const [pageNum, setPageNum] = useState(DEFAULT_PAGENUM);

  const updateSearch = newSearch => {
    setSearch(newSearch);
    setSortBy(RELEVANCE.value);
  };
  const updateFilter = filter => {
    setFilters(filter);
    setSortBy(RELEVANCE.value);
  };
  const updateSortBy = order => setSortBy(order);
  const updatePageNum = page => setPageNum(page);

  const resetSearch = () => {
    setSearch(DEFAULT_SEARCH);
    setFilters(DEFAULT_FILTERS);
    setSortBy(DEFAULT_SORTBY);
    setPageNum(DEFAULT_PAGENUM);
  };

  const hasSearchParams = () => {
    return search !== DEFAULT_SEARCH || filters !== DEFAULT_FILTERS;
  };

  return (
    <SearchContext.Provider
      value={{
        search,
        filters,
        sortBy,
        pageNum,
        updateSearch,
        updateFilter,
        updateSortBy,
        updatePageNum,
        resetSearch,
        hasSearchParams,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

SearchProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const SearchConsumer = SearchContext.Consumer;

export { SearchProvider, SearchConsumer, SearchContext };
